import { defineStore } from 'pinia';
import { ref, watchEffect } from 'vue';

export const useThemeStore = defineStore('theme', () => {
  // Zustand aus localStorage lesen oder Systempräferenz verwenden
  const preferredTheme = localStorage.getItem('theme');
  const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const initialCalculatedTheme = preferredTheme || (prefersDark ? 'dark' : 'light');
  const currentTheme = ref(initialCalculatedTheme);
  console.log(`[Theme Init] localStorage='${preferredTheme}', prefersDark=${prefersDark}, Initial theme set to: ${currentTheme.value}`);

  // Funktion zum Umschalten des Themes
  function toggleTheme() {
    const oldTheme = currentTheme.value;
    console.log(`[toggleTheme] Before toggle: currentTheme is '${oldTheme}'`);
    currentTheme.value = oldTheme === 'light' ? 'dark' : 'light';
    console.log(`[toggleTheme] After toggle: currentTheme is now '${currentTheme.value}'`);
  }

  // Funktion zum expliziten Setzen des Themes
   function setTheme(theme) {
    if (['light', 'dark'].includes(theme)) {
        const oldTheme = currentTheme.value;
        currentTheme.value = theme;
        console.log(`[setTheme] Explicitly set theme from '${oldTheme}' to '${currentTheme.value}'`);
    } else {
        console.warn(`[setTheme] Invalid theme: ${theme}. Allowed are 'light' or 'dark'.`);
    }
  }

  // Watcher, um die Klasse auf <html> zu setzen und im localStorage zu speichern (KORREKTE LOGIK)
  watchEffect(() => {
    const root = document.documentElement;
    if (currentTheme.value === 'dark') {
      root.classList.add('dark');
      console.log(`[watchEffect] currentTheme is '${currentTheme.value}', adding 'dark' class.`);
    } else { // currentTheme.value === 'light'
      root.classList.remove('dark');
      console.log(`[watchEffect] currentTheme is '${currentTheme.value}', removing 'dark' class.`);
    }
    // Nur speichern, wenn es ein gültiger Wert ist (verhindert Speichern von null/undefined)
    if (currentTheme.value) {
        localStorage.setItem('theme', currentTheme.value);
        console.log(`[watchEffect] Saved theme '${currentTheme.value}' to localStorage.`);
    }
  });

  // Watcher für Systempräferenz-Änderungen
   const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
   const handleSystemThemeChange = (e) => {
       console.log(`[System Theme Change] System changed to ${e.matches ? 'dark' : 'light'}`);
       // Nur ändern, wenn kein Theme explizit vom User gespeichert wurde
       if (!localStorage.getItem('theme')) {
            console.log('[System Theme Change] No theme in localStorage, applying system theme.');
            setTheme(e.matches ? 'dark' : 'light');
       }
   };
   mediaQuery.addEventListener('change', handleSystemThemeChange);

  return {
    currentTheme,
    toggleTheme,
    setTheme
  };
}); 